export default __webpack_public_path__ + "static/media/Background_00078.653f2059.png";